import React from 'react';
import { compact } from 'lodash';

import Chapter from '../../Chapter';
import { AssetType } from '../../../../utils/storage';

import Nby from './nby/nby';
import { NbyDataType } from './nby/types';

import './styles/fonts.scss';


export default class NbyChapter extends Chapter<NbyDataType> {
    component = () => (
        <div
            style={{
                width: '100%',
                height: '100%',
                ['--hoi-background-red' as string]: '#FF2800',
                ['--hoi-font-vertical-correction' as string]: '1',
            }}
        >
            <Nby data={this.data} />
        </div>
    )

    fonts = [
        'helvetica-neue-hoi-ehq',
        'palatino',
    ]

    canLoop = true

    calculateDuration() {
        const {
            variant = 'steps',
            steps = [],
        } = this.data;

        if (variant === 'pricing') {
            return 30;
        }

        // Matches nby store default stepDuration (10s per step)
        return Math.max(steps.length, 1) * 10;
    }

    getAssetsToCache(): AssetType[] {
        const {
            lockup,
            logo,
            pricingMedia = [],
            steps = [],
        } = this.data;

        const stepMedia = steps.flatMap(step => step?.media || []);

        return compact([lockup, logo, ...pricingMedia, ...stepMedia])
            .filter(media => media?.url);
    }
}
